import { settings as en_settings } from "../en/settings";

/** settings — RU slice (55 keys). */
export const settings: Record<keyof typeof en_settings, string> = {
  settings_account_section_title: "Аккаунт",
  settings_email_title: "Почта",
  settings_email_subtitle: "Изменить адрес почты",
  settings_preferences_section_title: "Настройки",
  settings_language_title: "Язык",
  settings_language_subtitle: "Язык приложения",
  settings_push_notifications_title: "Пуш-уведомления",
  settings_push_notifications_subtitle:
    "Получай уведомления на своём устройстве",
  settings_push_notifications_test_title: "Тестовое уведомление",
  settings_push_notifications_test_description:
    "Отправь тестовое уведомление, чтобы проверить, работают ли пуши на этом устройстве.",
  settings_push_notifications_test_disabled_hint:
    "Включи пуш-уведомления выше, чтобы отправить тест.",
  settings_push_notifications_test_button: "Отправить тест",
  settings_push_notifications_test_button_loading: "Отправляем...",
  settings_dark_mode_title: "Тёмная тема",
  settings_dark_mode_subtitle: "Использовать тёмную тему",
  settings_legal_support_section_title: "Правовое и поддержка",
  settings_about_us_title: "О нас",
  settings_about_us_subtitle: "Узнай больше о Linqx",
  settings_about_version: "Версия",
  settings_about_description:
    "Linqx помогает знакомиться с людьми рядом и превращать симпатии в реальные встречи.",
  settings_about_visit_website: "Открыть сайт",
  settings_privacy_policy_title: "Политика конфиденциальности",
  settings_privacy_policy_subtitle: "Как мы защищаем твои данные",
  settings_terms_of_use_title: "Условия использования",
  settings_terms_of_use_subtitle: "Прочитай наши условия",
  settings_app_version_title: "Версия приложения",
  settings_logout_button: "Выйти",
  settings_logout_confirmation_title: "Выход",
  settings_logout_confirmation_message: "Точно хочешь выйти?",
  settings_logout_confirmation_confirm: "Выйти",
  settings_email_current_email_title: "Текущая почта",
  settings_email_new_email_title: "Новый адрес почты",
  settings_email_address_label: "Адрес почты",
  settings_email_address_placeholder: "Введи новый адрес почты",
  settings_email_update_button: "Обновить почту",
  settings_email_updating_button: "Обновляем...",
  settings_email_info_message:
    "Нужно подтвердить новый адрес почты, прежде чем изменение вступит в силу. Мы отправим письмо для подтверждения на новый адрес.",
  settings_success_title: "Готово",
  settings_success_email_updated: "Почта успешно обновлена",
  settings_success_billing_updated: "Платёжный адрес успешно обновлён",
  settings_error_invalid_email: "Введи корректный адрес почты",
  settings_error_fill_required_fields: "Заполни все обязательные поля",
  settings_ok_button: "ОК",
  notifications_success_title: "Готово",
  notifications_success_settings_updated:
    "Настройки уведомлений успешно обновлены",
  notifications_success_token_registered: "Пуш-уведомления успешно подключены",
  notifications_success_token_updated: "Пуш-токен успешно обновлён",
  notifications_success_token_deleted: "Пуш-токен успешно удалён",
  notifications_success_test_scheduled:
    "Тестовое уведомление успешно запланировано",
  notifications_error_title: "Ошибка",
  notifications_error_update_failed:
    "Не удалось обновить настройки уведомлений",
  notifications_error_register_failed: "Не удалось подключить пуш-уведомления",
  notifications_error_delete_failed: "Не удалось удалить пуш-токен",
  notifications_error_not_supported:
    "Пуш-уведомления не поддерживаются на этом устройстве",
  notifications_error_permission_denied: "Доступ к уведомлениям запрещён",
  notifications_error_test_failed: "Не удалось отправить тестовое уведомление",
  notifications_confirm_delete_title: "Удалить пуш-токен",
  notifications_confirm_delete_message: "Точно хочешь удалить этот пуш-токен?",
  notifications_confirm_delete_cancel: "Отмена",
  notifications_confirm_delete_confirm: "Удалить",
  settings_danger_section_title: "Опасная зона",
  settings_deactivate_title: "Деактивировать аккаунт",
  settings_deactivate_subtitle: "Скрыть профиль и выйти. Обратимо.",
  settings_deactivate_confirm_title: "Деактивировать аккаунт?",
  settings_deactivate_confirm_message:
    "Профиль скроется везде, и ты выйдешь на всех устройствах. Снова войдёшь — аккаунт активируется.",
  settings_deactivate_confirm_confirm: "Деактивировать",
  settings_deactivate_error: "Не удалось деактивировать. Попробуй ещё раз.",
};
